import React from 'react';
import { Card } from '../ui/Card';
import { Bus, Zap, Fuel, Wrench, TrendingUp, Activity, Gauge } from 'lucide-react';
import { BusStats as BusStatsType } from '../../types';

interface BusStatsProps {
  stats: BusStatsType;
}

export const BusStats: React.FC<BusStatsProps> = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Buses',
      value: stats.totalBuses,
      icon: Bus,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Active Buses',
      value: stats.activeBuses,
      icon: Activity,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'In Service',
      value: stats.inServiceBuses,
      icon: TrendingUp,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
    },
    {
      title: 'Maintenance Due',
      value: stats.maintenanceDue,
      icon: Wrench,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      title: 'Electric Buses',
      value: stats.electricBuses,
      icon: Zap,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      title: 'Diesel Buses',
      value: stats.dieselBuses,
      icon: Fuel,
      color: 'text-gray-600',
      bgColor: 'bg-gray-50',
    },
    {
      title: 'Hybrid Buses',
      value: stats.hybridBuses,
      icon: Gauge,
      color: 'text-teal-600',
      bgColor: 'bg-teal-50',
    },
    {
      title: 'Utilization Rate',
      value: `${stats.utilizationRate.toFixed(1)}%`,
      icon: TrendingUp,
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={index} className="p-6">
            <div className="flex items-center">
              <div className={`p-3 rounded-lg ${stat.bgColor}`}>
                <Icon className={`h-6 w-6 ${stat.color}`} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-secondary-600">{stat.title}</p>
                <p className="text-2xl font-bold text-secondary-900">{stat.value}</p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
